export const OfferHasExpired = {
	en: "We‘re sorry，the offer has expired.",
	cs: "Litujeme, nabídka vypršela.",
	da: "Vi beklager, men tilbuddet er udløbet.",
	de: "Es tut uns leid, das Angebot ist nicht mehr gültig.",
	el: "Λυπούμαστε, η προσφορά έχει λήξει.",
	es: "Lo sentimos, la oferta se ha terminado.",
	hr: "Žao nam je， ponuda je istekla.",
	fr: "Nous sommes désolés, l'offre a expiré.",
	hu: "Sajnáljuk, az ajánlat lejárt.",
	id: "Maaf, penawaran ini telah kedaluwarsa.",
	it: "Siamo spiacenti, l'offerta è scaduta.",
	ja: "大変申し訳ありません。有効期限が過ぎてしまいました。",
	ko: "죄송합니다. 쿠폰이 만료되었습니다.",
	nl: "Sorry, het aanbod is verlopen.",
	no: "Vi beklager, tilbudet har utløpt.",
	pl: "Przepraszamy, oferta wygasła.",
	pt: "Lamentamos, a oferta expirou.",
	ro: "Ne pare rău, oferta a expirat.",
	ru: "К сожалению, срок действия предложения истек.",
	sv: "Tyvärr, erbjudandet har gått ut.",
	th: "ขออภัย ข้อเสนอหมดอายุแล้ว",
	tr: "Üzgünüz, teklifin süresi doldu.",
	ar: "نأسف، انتهى العرض",
};
export const EndsIn = {
	en: "Starts On",
	cs: "Začíná dne",
	da: "Starter på",
	de: "Beginnt am",
	el: "Ξεκινά στις",
	es: "Comienza en",
	hr: "Započinje",
	fr: "Commence le",
	hu: "Kezdődik",
	id: "Mulai",
	it: "Comincia il",
	ja: "開始日",
	ko: "시작",
	nl: "Begint op",
	no: "Starter den",
	pl: "Rozpoczęcie",
	pt: "Começa Em",
	ro: "Începe în",
	ru: "Начало:",
	sv: "Börjar den",
	th: "เริ่มใน",
	tr: "Başlama Zamanı",
	ar: "العرض يبدأ في",
};
export const StartsOn = {
	en: "Starts On",
	cs: "Začíná dne",
	da: "Starter på",
	de: "Beginnt am",
	el: "Ξεκινά στις",
	es: "Comienza en",
	hr: "Započinje",
	fr: "Commence le",
	hu: "Kezdődik",
	id: "Mulai",
	it: "Comincia il",
	ja: "開始日",
	ko: "시작",
	nl: "Begint op",
	no: "Starter",
	pl: "Rozpoczęcie",
	pt: "Começa Em",
	ro: "Începe în",
	ru: "Начало:",
	sv: "Börjar den",
	th: "เริ่มใน",
	tr: "Başlama Zamanı",
	ar: "العرض يبدأ في",
};
export const MonthsLan: { [key: string]: string[] } = {
	en: [
		"January",
		"February",
		"March",
		"April",
		"May",
		"June",
		"July",
		"August",
		"September",
		"October",
		"November",
		"December",
	],
	nl: [
		"januari-",
		"februari",
		"maart",
		"april",
		"mei",
		"juni-",
		"juli-",
		"augustus",
		"september",
		"oktober",
		"november",
		"december",
	],
	da: [
		"januar",
		"februar",
		"marts",
		"April",
		"Kan",
		"juni",
		"juli",
		"august",
		"september",
		"oktober",
		"november",
		"december",
	],
	sv: [
		"januari",
		"februari",
		"Mars",
		"april",
		"Maj",
		"juni",
		"juli",
		"augusti",
		"september",
		"oktober",
		"november",
		"december",
	],
	fi: [
		"tammikuu",
		"helmikuu",
		"maaliskuu",
		"huhtikuu",
		"saattaa",
		"kesäkuu",
		"heinäkuu",
		"elokuu",
		"syyskuu",
		"lokakuu",
		"marraskuu",
		"joulukuu",
	],
	it: [
		"gennaio",
		"febbraio",
		"marzo",
		"aprile",
		"Maggio",
		"giugno",
		"luglio",
		"agosto",
		"settembre",
		"ottobre",
		"novembre",
		"dicembre",
	],
	pt: [
		"Janeiro",
		"fevereiro",
		"Março",
		"abril",
		"Maio",
		"Junho",
		"julho",
		"agosto",
		"setembro",
		"Outubro",
		"novembro",
		"dezembro",
	],
	hu: [
		"január",
		"február",
		"március",
		"április",
		"Lehet",
		"június",
		"július",
		"augusztus",
		"szeptember",
		"október",
		"november",
		"december",
	],
	no: [
		"januar",
		"februar",
		"mars",
		"april",
		"Kan",
		"juni",
		"juli",
		"august",
		"september",
		"oktober",
		"november",
		"desember",
	],
	cs: [
		"leden",
		"Únor",
		"březen",
		"duben",
		"Smět",
		"červen",
		"červenec",
		"srpen",
		"září",
		"říjen",
		"listopad",
		"prosinec",
	],
	pl: [
		"styczeń",
		"luty",
		"Marsz",
		"kwiecień",
		"Może",
		"czerwiec",
		"lipiec",
		"sierpień",
		"wrzesień",
		"październik",
		"listopad",
		"grudzień",
	],
	fr: [
		"janvier",
		"février",
		"Mars",
		"avril",
		"Mai",
		"juin",
		"juillet",
		"août",
		"septembre",
		"octobre",
		"novembre",
		"décembre",
	],
	es: [
		"enero",
		"febrero",
		"marcha",
		"abril",
		"Mayo",
		"junio",
		"mes de julio",
		"agosto",
		"septiembre",
		"octubre",
		"noviembre",
		"diciembre",
	],
	de: [
		"Januar",
		"Februar",
		"März",
		"April",
		"Kann",
		"Juni",
		"Juli",
		"August",
		"September",
		"Oktober",
		"November",
		"Dezember",
	],
	he: [
		"יָנוּאָר",
		"פברואר",
		"מרץ",
		"אַפּרִיל",
		"מאי",
		"יוני",
		"יולי",
		"אוגוסט",
		"סֶפּטֶמבֶּר",
		"אוֹקְטוֹבֶּר",
		"נוֹבֶמבֶּר",
		"דֵצֶמבֶּר",
	],
	ja: ["1月", "2月", "行進", "四月", "五月", "六月", "7月", "8月", "9月", "10月", "11月", "12月"],
	ru: [
		"январь",
		"февраль",
		"маршировать",
		"апреля",
		"Может",
		"июнь",
		"июль",
		"август",
		"сентябрь",
		"октября",
		"ноябрь",
		"Декабрь",
	],
	ar: [
		"كانون الثاني",
		"شهر فبراير",
		"مارس",
		"أبريل",
		"مايو",
		"يونيو",
		"تموز",
		"أغسطس",
		"شهر سبتمبر",
		"اكتوبر",
		"شهر نوفمبر",
		"ديسمبر",
	],
	ko: [
		"일월",
		"이월",
		"행진",
		"4 월",
		"할 수있다",
		"유월",
		"칠월",
		"팔월",
		"구월",
		"십월",
		"십일월",
		"12 월",
	],
	tr: [
		"Ocak",
		"Şubat",
		"Mart",
		"Nisan",
		"Mayıs",
		"Haziran",
		"Temmuz",
		"Ağustos",
		"Eylül",
		"Ekim",
		"Kasım",
		"Aralık",
	],
	el: [
		"Ιανουάριος",
		"Φεβρουάριος",
		"Μάρτιος",
		"Απρίλιος",
		"Ενδέχεται",
		"Ιούνιος",
		"Ιούλιος",
		"Αύγουστος",
		"Σεπτέμβριος",
		"Οκτώβριος",
		"Νοέμβριος",
		"Δεκέμβριος",
	],
	hr: [
		"siječanj",
		"veljača",
		"ožujak",
		"travanj",
		"svibanj",
		"lipanj",
		"srpanj",
		"kolovoz",
		"rujan",
		"listopad",
		"studeni",
		"prosinac",
	],
	ro: [
		"ianuarie",
		"februarie",
		"Martie",
		"Aprilie",
		"Mai",
		"iunie",
		"iulie",
		"August",
		"Septembrie",
		"octombrie",
		"noiembrie",
		"decembrie",
	],
	th: [
		"มกราคม",
		"กุมภาพันธ์",
		"มีนาคม",
		"เมษายน",
		"อาจ",
		"มิถุนายน",
		"กรกฎาคม",
		"สิงหาคม",
		"กันยายน",
		"ตุลาคม",
		"พฤศจิกายน",
		"ธันวาคม",
	],
	id: [
		"Januari",
		"Februari",
		"Maret",
		"April",
		"Mungkin",
		"Juni",
		"Juli",
		"Agustus",
		"September",
		"Oktober",
		"November",
		"Desember",
	],
};
export const ViewMore = {
	en: "View More",
	cz: "Zobrazit více", // 捷克语
	da: "Se mere",
	de: "Mehr anzeigen",
	gr: "Δείτε περισσότερα", // 希腊语
	es: "Ver más", // 西班牙语
	hr: "Vidi više",
	fr: "Voir Plus",
	hu: "Tovább",
	it: "Vedi altro",
	ja: "もっと見る",
	ko: "더보기",
	nl: "Meer weergeven",
	no: "Se mer",
	pl: "Zobacz więcej",
	pt: "Ver Mais",
	ro: "Vezi Mai Multe",
	ru: "Подробнее",
	sv: "Visa mer",
	th: "ดูเพิ่ม",
	tr: "Daha Fazla Göster",
	ar: "مشاهدة المزيد",
	he: "ראה עוד",
	id: "lihat lebih banyak",
	fi: "Katso lisää",
};

export const BlankPageTips = {
	en: "Sorry, this activity is not currently supported in your country or region, please browse other activities.",
	cz: "Je nám líto, ale tato aktivita není aktuálně ve vaší zemi nebo regionu podporována, projděte si prosím jiné aktivity.",
	da: "Vi beklager, denne aktivitet er i øjeblikket ikke understøttet i dit land eller område. Gennemse andre aktiviteter.",
	de: "Wir bedauern sehr, dass diese Tätigkeit derzeit in Ihrem Land oder Ihrer Region nicht unterstützt wird. Bitte durchsuchen Sie andere Tätigkeiten.",
	es: "Lo sentimos, esta actividad no se admite actualmente en su país o región, examine otras actividades.",
	hr: "Nažalost, ova opcija trenutačno nije podržana u vašoj zemlji ili regiji. Pogledajte koje su vam druge opcije na raspolaganju. ",
	fr: "Désolé, cette activité n’est pas prise en charge actuellement dans votre pays ou région, veuillez consulter d’autres activités.",
	hu: "Sajnáljuk, ez a tevékenység jelenleg nem támogatott az Ön országában vagy régiójában. Kérjük, böngésszen a többi tevékenység között!",
	it: "Questa attività attualmente non è supportata nel tuo paese o nella tua area geografica. Cerca altre attività.",
	ja: "申し訳ありませんが、このアクティビティは現在、お住まいの国または地域ではサポートされていません。他のアクティビティをお探しください。",
	ko: "죄송합니다. 현재 거주하시는 국가나 지역에서 지원되지 않는 활동입니다. 그밖에 다른 활동을 찾아보세요.",
	nl: "Sorry, deze activiteit wordt momenteel niet ondersteund in uw land of regio. Blader door andere activiteiten.",
	no: "Beklager, denne aktiviteten støttes for øyeblikket ikke i landet eller regionen din, vennligst bla gjennom andre aktiviteter.",
	pl: "Przepraszamy, funkcja ta obecnie nie jest obsługiwana w Twoim kraju lub regionie, prosimy zapoznaj się z innymi funkcjami.",
	pt: "Lamentamos, mas de momento não é possível realizar esta atividade no seu país ou região. Consulte outras atividades.",
	ro: "Ne pare rău, această activitate nu este acceptată în prezent în țara sau regiunea dvs., vă rugăm să încercați alte activități.",
	ru: "К сожалению, эта операция в настоящее время не поддерживается в вашей стране или регионе. Ознакомьтесь с другими операциями.",
	sv: "Tyvärr, denna aktivitet stöds för närvarande inte i ditt land eller din region, bläddra bland andra aktiviteter.",
	th: "ขออภัย ประเทศหรือภูมิภาคของคุณไม่มีกิจกรรมนี้ให้บริการ โปรดดูกิจกรรมอื่น",
	tr: "Üzgünüz, bu işlem şu anda ülkenizde veya bölgenizde desteklenmiyor, lütfen diğer işlemlere göz atın.",
	he: "מצטערים, פעילות זו אינה נתמכת כעת במדינה או באזור שלכם, אנא עיינו בפעילויות אחרות.",
	ar: "عذرًا، هذا النشاط غير مدعوم حاليًا في بلدك أو منطقتك، يرجى تصفح الأنشطة الأخرى.",
	gr: "Λυπούμαστε, αυτή η δραστηριότητα δεν υποστηρίζεται προς το παρόν στη χώρα ή την περιοχή σας. Παρακαλούμε περιηγηθείτε σε άλλες δραστηριότητες.",
	fi: "Valitettavasti tätä toimintoa ei tällä hetkellä tueta maassasi tai alueellasi. Selaa muita toimintoja.",
};
export const GoShopping = {
	en: "Go Shopping",
	cz: "Jít nakupovat", // 捷克
	da: "Tag På Shopping",
	de: "Los geht's mit dem Shoppen",
	gr: "Πηγαίνετε για ψώνια",
	es: "Anda de compras",
	hr: "Započni kupovinu",
	fr: "Aller Faire du Shopping",
	hu: "Induljon a bevásárlás",
	id: "Pergi Berbelanja",
	it: "Continua gli acquisti",
	ja: "ショッピングする",
	ko: "쇼핑하기",
	nl: "Ga winkelen",
	no: "Gå på shopping",
	pl: "Czas na zakupy",
	pt: "Va às compras!",
	ro: "Mergeți la Cumpărături",
	ru: "За покупками",
	sv: "Shoppa",
	th: "ไปชอปปิง",
	tr: "Alışverişe Gidin",
	ar: "اذهب للتسوق",
};
